<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M21.532 19.38a.991.991 0 01-.72-.291 1.012 1.012 0 01-.301-.723 1.022 1.022 0 01.3-.724 1.003 1.003 0 01.721-.29.999.999 0 01.698.303 1.02 1.02 0 010 1.42.998.998 0 01-.698.304zm-11.043 0a.992.992 0 01-.721-.291 1.014 1.014 0 01-.3-.723 1.023 1.023 0 01.3-.724 1.004 1.004 0 01.72-.29.999.999 0 01.698.303 1.02 1.02 0 010 1.42.998.998 0 01-.697.304zm11.399-6.083L23.894 9.8a.42.42 0 00-.31-.62.41.41 0 00-.41.208l-2.028 3.538a12.134 12.134 0 00-5.13-1.12 12.34 12.34 0 00-5.141 1.11L8.848 9.378a.418.418 0 00-.41-.21.411.411 0 00-.35.304.423.423 0 00.039.318l1.996 3.495a11.867 11.867 0 00-4.258 3.99A12.03 12.03 0 004 22.832h24a11.969 11.969 0 00-1.855-5.554 11.807 11.807 0 00-4.257-3.982z"/></svg>
</template>

<script>
export default {
  name: 'brandAndroidFilled'
}
</script>
